var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.divClass},[_c('div',{staticClass:"d-inline-block font-weight-bold",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"d-inline px-1 font-weight-med text-no-wrap",style:(_vm.valStyle)},[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.val,_vm.truncate))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }